__turbopack_context__.v({
  "Logo": "Logo-module__ERZQ-W__Logo",
  "LogoText": "Logo-module__ERZQ-W__LogoText",
});
